import { createContext } from 'react';

interface Owner {
  id: string;
  machineName: string;
  type: 's' | 'g';
}

interface FileManagerContextValue {
  rootOwner: Owner | null;
}

export const FileManagerContext = createContext<FileManagerContextValue>({
  rootOwner: null,
});

interface Or2HistoryContextProviderProps {
  rootOwner: Owner;
  children: React.ReactNode;
}

export const FileManagerContextProvider = ({
  rootOwner,
  children,
}: Or2HistoryContextProviderProps) => {
  return (
    <FileManagerContext.Provider
      value={{
        rootOwner,
      }}
    >
      {children}
    </FileManagerContext.Provider>
  );
};
